import declare from "dojo/_base/declare";
import HtmlWidget from "csi/html/Widget";
import { featureTogglesStore } from "csi/state/rootStore";
import { omitBy } from "lodash";

const CompositionTab = declare(HtmlWidget, {
	/**
	 * @override
	 * Display the old Legacy views if the Care And Composition feature flag is turned off
	 */
	_resolveView() {		
		const compositionFeatureFlagEnabled = featureTogglesStore.CAREANDCOMPOSITION_DATASHEET_USE_REACT_UI;
		const omitIds = {
			CompositionLabel: !compositionFeatureFlagEnabled,
			BaseComposition: !compositionFeatureFlagEnabled,
			CompositionBySalesRegions: !compositionFeatureFlagEnabled,
			Composition: compositionFeatureFlagEnabled,
			ExceptionLanguageCompositionStrings: compositionFeatureFlagEnabled,
		};
		this.defView.defsByKey = omitBy(this.defView.defsByKey, (view) => omitIds[view.m_id]);
		this.inherited(arguments);	
	},
});

export = CompositionTab;